import { useEffect } from "react";
import i18next from "i18next";
import { MandatorType, useMandatorContext } from "@bn/theming";
import en from "@translations/en";
import de from "@translations/de";
import { setMandatorDefaultVariables } from "@translations/mandatorVariables";

const addTranslation = async (mandatorSlug: MandatorType) => {
  i18next.addResourceBundle("en", "translation", en, true, true);
  i18next.addResourceBundle("de", "translation", de, true, true);

  const mandatorResource = await import(
    `../translations/mandators/${mandatorSlug}.ts`
  )
    .then((module) => module.default)
    .catch(() => ({}));

  const enResource = mandatorResource.en?.translation ?? mandatorResource.en;
  const deResource = mandatorResource.de?.translation ?? mandatorResource.de;

  if (enResource) {
    i18next.addResourceBundle("en", "translation", enResource, true, true);
  }
  if (deResource) {
    i18next.addResourceBundle("de", "translation", deResource, true, true);
  }
};

export const useMandatorSpecificTranslations = () => {
  const { mandatorSlug } = useMandatorContext();

  useEffect(() => {
    if (!mandatorSlug) return;
    setMandatorDefaultVariables(mandatorSlug);
    addTranslation(mandatorSlug);
  }, [mandatorSlug]);
};
